import { PageNotFound, Permission } from '@campx-org/shared'
import AdminRouteGuard from 'components/AdminRouteGuard'
import {
  AdminBookletDetail,
  AdminBundleBooklets,
  AdminBundleList,
  AdminExaminationList,
  AdminSubjectList,
  BundleView,
  BundlesAssigned,
  ExamsView,
  InternalExamBundleView,
  InternalExamBundles,
} from 'pages'
import { AdminInternalBookletDetailPage } from 'pages/Admin/AdminBookletDetailPage'
import { AdminInternalBundleBookletsPage } from 'pages/Admin/AdminBundleBookletsPage'
import { AdminInternalBundleListPage } from 'pages/Admin/AdminBundleListPage'
import { AdminInternalSubjectListPage } from 'pages/Admin/AdminSubjectListPage'
import Bundles from 'pages/ExternalExam/PhysicalEvaluation'
import { BundleMarksView } from 'pages/ExternalExam/PhysicalEvaluation/BundleMarksView'
import { Navigate } from 'react-router-dom'

export const baseRoutes = [
  {
    index: true,
    element: <Navigate to="digital" />,
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
  },
  {
    path: 'digital',
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
    children: [
      {
        index: true,
        element: <Navigate to="bundles-assigned" />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
      {
        path: 'bundles-assigned',
        element: <BundlesAssigned />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
      {
        path: 'bundles-assigned/:bundleId',
        element: <BundleView />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
    ],
  },
  {
    path: 'physical/bundles',
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
    element: <Bundles />,
    children: [
      {
        path: ':bundleId',
        element: <BundleMarksView />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
    ],
  },
  {
    path: 'exams-view',
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
    element: <ExamsView />,
  },
  {
    path: 'admin',
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
    children: [
      { index: true, element: <Navigate to="/admin/examinations" /> },
      {
        path: 'examinations',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminExaminationList />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'examinations/:examGroupId/subjects',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminSubjectList />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'examinations/:examGroupId/subjects/bundles',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminBundleList />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'examinations/:examGroupId/bundles/:bundleId/booklets',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminBundleBooklets />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'examinations/:examGroupId/bundles/:bundleId/booklets/:studExternalId',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminBookletDetail />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'internal/:examGroupId/subjects',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminInternalSubjectListPage />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'internal/:examGroupId/subjects/bundles',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminInternalBundleListPage />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'internal/:examGroupId/bundles/:evaluationBundleId/booklets',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminInternalBundleBookletsPage />
          </AdminRouteGuard>
        ),
      },
      {
        path: 'internal/:examGroupId/bundles/:evaluationBundleId/booklets/:evaluationBookletId',
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
        element: (
          <AdminRouteGuard>
            <AdminInternalBookletDetailPage />
          </AdminRouteGuard>
        ),
      },
    ],
  },
  {
    path: 'internal',
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
    children: [
      {
        index: true,
        element: <Navigate to="bundles" />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
      {
        path: 'bundles',
        element: <InternalExamBundles />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
      {
        path: 'bundles/:bundleEvaluatorId',
        element: <InternalExamBundleView />,
        permissionKey: Permission.CAN_DASHBOARD_VIEW,
      },
    ],
  },
  {
    path: '*',
    element: <PageNotFound />,
  },
]
